import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit,MdHolidayVillage  } from 'react-icons/md';
import styles from "./holidays.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalHolidays from './modalHolidays';
import Select from 'react-select';



export default function Holidays(props) {
    const { windowSize } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [holidayEdit, setHolidayEdit] = useState(null);

    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [mesSelect, setMesSelect] = useState('');
    const [aniosSelect, setAniosSelect] = useState('');

const generarAniosSelect = () => {
  const aniosActual = new Date().getFullYear();
 
  const aniosArray = [];

  // Año anterior
  aniosArray.push({
    value: aniosActual - 1,
    label: aniosActual - 1
  });

  // Año actual
  aniosArray.push({
    value: aniosActual,
    label: aniosActual
  });

  // Próximos 2 años
  for (let i = 1; i <= 2; i++) {
    aniosArray.push({
      value: aniosActual + i,
      label: aniosActual + i
    });
  }

  return aniosArray;
};

const anios = generarAniosSelect();


const selectAnioActual= () => {
     const aniosActual = new Date().getFullYear();
    let findAnioActual = anios.find(a => a.value === aniosActual);
    if (findAnioActual) {
        setAniosSelect(findAnioActual);
    }
};

    const meses = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' },
    ];



    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            width: "70px",
        },
        {
            name: 'Fecha',
             selector: row => row.date?row.date.split("T")[0]:"-",
            flex: "1",
            minWidth: "200px"
        },
        {
            name: 'Descripción',
            selector: row => row.description,
            flex: "1",
            minWidth: "200px"
        },
        {
            name: 'Estatus',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <span className={row.status ? "badge bg-success" : "badge bg-danger"}>{row.status ? "Activo" : "Inactivo"}</span>
                    </div>
                )
            },
            minWidth: "200px"
        },
         {
            name: '',
            cell: (row) => {
                return (
                    <div style={{ display: "flex",position:'sticky',left:0,background:"white",zIndex:"1" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setHolidayEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.id)}><MdDelete /></button>
                    </div>
                )
            },
            width: "100px",

        },

    ];

    const handleDelete = (id) => {
            Swal.fire({
                        title: "Esta segur@ que desea eliminar el dia festivo",
                        showCancelButton: true,
                        confirmButtonText: "Eliminar",
                        denyButtonText: "Cancelar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            api(SERVICE.deleteDiasFestivos + `?HolidaysId=${id}`, {}, "DELETE")
                                .then((data) => {
                                    handleUpdate();
                                })
                                .catch((err) => {
                                    console.log(err);
                                })
                        }
                    });
        }


    const handleUpdate = () => {
        let mes = 0,anio = 0;
        if(mesSelect!=null){
            if(mesSelect.value != undefined){
                mes=mesSelect.value;
            }
        }
       
        if(aniosSelect!=null){
            if(aniosSelect.value != undefined){
                anio=aniosSelect.value;
            }
        }
       
        api(SERVICE.getInfoDiasFestivos + `?mes=${mes}&anio=${anio}&Page=${page}&PageSize=${perPage}`)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    arrayTemp = data.data.data;
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
  
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        handleUpdate();
    }, [page, perPage,mesSelect,aniosSelect])
     useEffect(() => {
        selectAnioActual();
    }, [])

    return (
        <>
            <WindowLayout
                title="Dias Festivos"
                route={["Catálogos","Dias Festivos"]}
                icon={<MdHolidayVillage />} // Poner icono
            >
                <div className='paperContainer'>
                     <div className={styles.containerButtomTop}>
                         <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>
                    <div style={{ display: "flex", justifyContent: "left", alignItems: "center", flexWrap: "wrap" }}>
                      <div class={styles.itemForm} style={{ marginBottom: "10px", width: "200px",zIndex: 4  }}>
                            <label class="form-label">Año </label>
                             <Select isClearable  options={anios} class="form-control" value={aniosSelect} onChange={(e) => setAniosSelect(e)} />
                        </div>
                         <div class={styles.itemForm} style={{ marginBottom: "10px", width: "200px",zIndex: 4  }}>
                            <label class="form-label">Mes </label>
                             <Select isClearable options={meses} class="form-control" value={mesSelect} onChange={(e) => setMesSelect(e)} />
                        </div>
                    </div>
                   
                     
                  
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalHolidays
                show={showModal}
                setShow={setShowModal}
                dataEdit={holidayEdit}
                setDataEdit={setHolidayEdit}
                handleUpdate={handleUpdate}
            />
        </>
    );
} 